// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3BOae","location":"Header_location__3Pn-g"};